export const buildIncludedKeySet = (selectedTemplate) => {
    const out = new Set();
    if (!selectedTemplate?.cdeStandards) return out;

    for (const std of selectedTemplate.cdeStandards) {
        for (const gle of std.gles ?? []) {
            if (gle?.included) out.add(`GLE:${gle.key}`);

            for (const eo of gle.evidenceOutcomes ?? []) {
                if (eo?.included) out.add(`EVIDENCE_OUTCOME:${eo.key}`);

                for (const eoc of eo.evidenceOutcomeChildList ?? []) {
                    if (eoc?.included) out.add(`EVIDENCE_OUTCOME_CHILD:${eoc.key}`);
                }
            }
        }
    }
    return out;
};

export const makeKey = (n) => `${n.contentType}:${n.contentId}`;

// For CURRENT we key by templateContentId; for DIFF we key by contentId
export const idFor = (node, dataType) => (dataType === "CURRENT" ? node?.templateContentId : node?.contentId);

export const makeKeyFor = (node, dataType) => `${node?.contentType}:${idFor(node, dataType)}`;
